@if (showLabel) { @if (showLabel) {

<mat-form-field appearance="fill" class="w-full automtic-form-desing-form-only add-automtic-form-desing full-width app__attributes-form-field">
  <mat-label class="automtic-form-desing-lable">
    {{ title ? title : 'Value' }}
    @if(fromBalanceAlert){
    <span [matTooltip]="tooltipText" matTooltipClass="customeTooltip"> <img [src]="imgSource" /> </span>
    }
  </mat-label>
  <input
    #myInput
    [ngClass]="{ 'app__disabled--counter--btn': disableInput }"
    matInput
    placeholder="0.00"
    type="text"
    [(ngModel)]="initial"
    (change)="setInputValue(this.initial)"
    (ngModelChange)="valueChanges.next($event)"
    max="18"
    [maxlength]="18"
    [defaultValue]="'0.00'"
    [disabled]="disableInput"
    (click)="selectAll()"
  />
  @if (((fromAddBalance && title != 'Shares') || fromPurchasePrice || fromBalanceAlert) && !hideIcons) {
  <mat-icon
    matSuffix
    [class]="styledIcon ? 'bg-[#f5f5f6] rounded-[4px] flex items-center justify-center top-0 right-0 absolute h-[48px] w-[46px]' : ''"
    >{{ title === 'Coinsurance' || title?.includes('Percentage') || title?.toLowerCase()?.includes('interest') ? '%' : '$' }}</mat-icon
  >
  } @if (fromPrivateDebt || fromRolePlayers) {
  <mat-icon
    matSuffix
    [class]="
      styledIcon ? 'bg-[#f5f5f6] rounded-[4px] flex items-center justify-center top-0 right-0 absolute h-[48px] w-[46px] number-input-icon' : ''
    "
    [ngClass]="{ 'app__disabled--counter--btn': disableInput }"
    >%</mat-icon
  >
  }
</mat-form-field>

} } @else { @if (!showLabel && !isCounter) {
<mat-form-field class="app__table--form--field w-full flex items-end text-end fornt-bold app__attributes-form-field" appearance="outline">
  <input
    #myInput
    style="padding-bottom: 5px !important"
    matInput
    placeholder="0.00"
    type="text"
    [(ngModel)]="initial"
    (change)="fromRegister ? null : setInputValue(this.initial)"
    max="18"
    [maxlength]="18"
    [defaultValue]="'0.00'"
    [disabled]="disableInput"
    (click)="selectAll()"
  />
</mat-form-field>
} @if(!showLabel && isCounter){ @if(!dynamicControl){
<input
  #myInput
  class="w-[70px] h-[35px] rounded-md bg-white border border-solid border-[#d3dce8] box-border text-end text-sm font-open-sans font-semibold pl-1 pr-5"
  [ngClass]="{ 'app__disabled--counter--btn': disableInput }"
  matInput
  placeholder="0.00"
  type="text"
  [(ngModel)]="initial"
  (change)="fromRegister ? null : setInputValue(this.initial)"
  max="18"
  [maxlength]="18"
  [defaultValue]="'0.00'"
  [disabled]="disableInput"
  (click)="selectAll()"
/>
<span
  class="absolute right-[6px] top-0 bottom-0 leading-[34px] text-sm font-semibold number-input-icon"
  [ngClass]="{ 'app__disabled--counter--btn': disableInput }"
  >%</span
>
} @if(dynamicControl){

<input
  #myInput
  class="w-full h-[44px] rounded bg-white border-[1.5px] border-solid border-[#25508E] box-border text-center text-sm font-open-sans font-semibold px-4 py-6 outline-none shadow-none"
  [ngClass]="{ 'app__disabled--counter--btn': disableInput }"
  matInput
  placeholder="0.00"
  type="text"
  [(ngModel)]="initial"
  (change)="fromRegister ? null : setInputValue(this.initial)"
  max="18"
  [maxlength]="18"
  [defaultValue]="'0.00'"
  [disabled]="disableInput"
  (click)="selectAll()"
/>

}}}
